import { Component, input, output } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { ConfirmImportConfigurationDialogOptions } from './../import-into-configuration-drawer/import-into-configuration-drawer.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-import-configuration-confirm-dialog',
  templateUrl: './import-configuration-confirm-dialog.component.html',
  styleUrls: ['./import-configuration-confirm-dialog.component.scss'],
  standalone: false,
})
export class ImportConfigurationConfirmDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly data = input<ConfirmImportConfigurationDialogOptions>();

  readonly modalClosed = output<boolean | void>();

  cancel() {
    this.modalClosed.emit();
  }

  confirm() {
    this.modalClosed.emit(true);
  }
}
